import { t } from 'i18next';

import type {
  DeviceHealthMessage,
  RppgAbortReasonCode,
} from './types';

function humanizeReasonCode(code: string): string {
  return code
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function mapDeviceHealthReason(
  code: RppgAbortReasonCode,
): DeviceHealthMessage | null {
  switch (code) {
    case 'LOW_BATTERY':
      return {
        header: t('medsi_device_low_battery_title'),
        description: t('medsi_device_low_battery_message'),
      };
    case 'LOW_POWER_MODE':
      return {
        header: t('medsi_device_low_power_mode_title'),
        description: t('medsi_device_low_power_mode_message'),
      };
    case 'THERMAL_THROTTLING':
      return {
        header: t('medsi_device_thermal_title'),
        description: t('medsi_device_thermal_message'),
      };
    case 'CAMERA_INTERRUPTED':
      return {
        header: t('medsi_device_camera_interrupted_title'),
        description: t('medsi_device_camera_interrupted_message'),
      };
    case 'LOW_FRAME_RATE':
      return {
        header: t('medsi_device_low_frame_rate_title'),
        description: t('medsi_device_low_frame_rate_message'),
      };
    default:
      return null;
  }
}

export function mapDeviceHealthReasons(
  reasons: RppgAbortReasonCode[] | null | undefined,
): DeviceHealthMessage[] {
  if (!reasons?.length) {
    return [
      {
        header: t('error'),
        description: t('medsi_device_health_abort_intro'),
      },
    ];
  }

  const seen = new Set<string>();
  const mapped: DeviceHealthMessage[] = [];

  for (const code of reasons) {
    const key = String(code);
    if (seen.has(key)) continue;
    seen.add(key);

    const deviceMapped = mapDeviceHealthReason(code);
    if (deviceMapped) {
      mapped.push(deviceMapped);
    } else {
      mapped.push({
        header: humanizeReasonCode(key),
        description: t('medsi_device_health_abort_intro'),
      });
    }
  }

  return mapped;
}
